import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'SelectActivity',
  props: ['dataObj'],
  data: function () {
    return {
      appData: {},
      tasks: [],
      message: '',
      radio: ''
    };
  },
  watch: {
    radio: function (value) {
      this.appData.activityId = value;
      this.appData.taskType = this.tasks.filter((a) => a.activityId == value)[0].taskType;
    }
  },
  created() {
    this.appData = this.dataObj;
    this.getTasks();
  },
  methods: {
    getTasks() {
      axios
        .post('/EmployeeApplication/GetSelectionTaskItems', { Value: this.appData.appId })
        .then((response) => {
          if (response.data.data.status == 0) {
            this.tasks = response.data.items;
            if (this.tasks.length == 1) {
              this.appData.activityId = this.tasks[0].activityId;
              this.radio = this.appData.activityId;
            }
          } //else this.$alertMsg(response.data.data.text);
        })
        .catch((e) => {
          this.$router.push('/login');
        });
    }
  }
};
